import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const usePropertyDefinition = () => usePropertyContext().property;